<template>
  <el-row :gutter="uploadType === 'single' ? 10 : 0">
    <el-col :span="uploadType === 'single' ? 10 : 24">
      <el-card style="height: 600px;overflow-y: auto;" shadow="hover">
        <div class="text-sm mb-2"><span>选择上传分类</span></div>
        <el-tabs class="trackTab" v-model="activeTrack">
          <el-tab-pane label="文件类" name="1">
            <div slot="label" class="flex flex-col items-center">
              <span class="pb-1 pr-1">文件类</span>
              <span class="pr-1 text-mini">word、pdf、excel</span>
            </div>
            <el-radio-group v-model="radio1" size="small" @input="val => radioInput(val, '1')">
              <el-radio v-for="(item, index) in trackForm.fileList" :key="index" :label="item.typeLabel" border>{{item.typeLabel}}</el-radio>
            </el-radio-group>
          </el-tab-pane>
          <el-tab-pane label="证件证明类" name="2">
            <div slot="label" class="flex flex-col items-center">
              <span class="pb-1 px-1">证件证明类</span>
              <span class="px-1 text-mini">word、pdf、excel</span>
            </div>
            <el-radio-group v-model="radio2" size="small" @input="val => radioInput(val, '2')">
              <el-radio v-for="(item, index) in trackForm.certificate" :key="index" :label="item.typeLabel" border>{{item.typeLabel}}</el-radio>
            </el-radio-group>
          </el-tab-pane>
          <el-tab-pane label="视频/照片" name="3">
            <div slot="label" class="flex flex-col items-center">
              <span class="pb-1 px-1">视频/照片</span>
              <span class="px-1 text-mini">png、jpg</span>
            </div>
            <el-radio-group v-model="radio3" size="small" @input="val => radioInput(val, '3')">
              <el-radio v-for="(item, index) in trackForm.videoPhoto" :key="index" :label="item.typeLabel" border>{{item.typeLabel}}</el-radio>
            </el-radio-group>
          </el-tab-pane>
          <el-tab-pane label="人车信息" name="4" v-if="updateType === 'accident'">
            <div slot="label" class="flex flex-col items-center">
              <span class="pb-1 pl-1 pr-2">人车信息</span>
              <span class="pl-1 pr-2 text-mini">word、pdf、excel、png、jpg</span>
            </div>
            <el-radio-group v-model="radio4" size="small" @input="val => radioInput(val, '4')">
              <el-radio v-for="(item, index) in trackForm.information" :key="index" :label="item.typeLabel" border>{{item.typeLabel}}</el-radio>
            </el-radio-group>
          </el-tab-pane>
          <el-tab-pane label="全部" name="0">
            <div slot="label" class="flex flex-col items-center" v-if="updateType === 'carrier'">
              <span class="pb-1 pl-1 pr-2">全部</span>
              <span class="pl-1 pr-2 text-mini">word、pdf、excel、png、jpg</span>
            </div>
            <el-radio-group v-model="radio0" size="small" @input="val => radioInput(val, '0')">
              <el-radio v-for="(item, index) in trackForm.all" :key="index" :label="item.typeLabel" border>{{item.typeLabel}}</el-radio>
            </el-radio-group>
          </el-tab-pane>
        </el-tabs>
        <el-form size="mini" label-width="110px">
          <el-form-item label="单据类型">
            <el-input v-model="uploadData.module" disabled></el-input>
          </el-form-item>
          <el-form-item label="文件分类">
            <el-input v-model="uploadData.sgFileType" disabled></el-input>
          </el-form-item>
          <el-form-item label="编号" v-if="uploadType === 'single'">
            <el-input v-model="uploadData.objectNo" disabled></el-input>
          </el-form-item>
          <el-form-item label="文件说明">
            <el-input v-model="uploadData.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label-width="80px">
            <el-upload
                class="upload-ali-demo"
                ref="refUploadAli"
                action
                :data="uploadData"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :auto-upload="false"
                accept=".jpg,.jpeg,.png,.pdf,.gif,.xls,.xlsx,.doc,.docx,.avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4,.mp3,.wma,.flac,.ape,.wav,.aac,.m4a"
                :before-upload="beforeAvatarUpload"
                multiple
                :on-exceed="handleExceed"
                :on-change="handleChange"
                :on-success="onSuccess"
                :on-error="onError"
                list-type="picture"
                :file-list="fileList">
              <!--:http-request="picUpload"-->
              <el-button slot="trigger" size="mini" type="primary" :style="editStatus ? 'display:none' : 'margin: 3px 5px;'" :disabled="onlySeeState" icon="el-icon-folder-opened">选择文件</el-button>
              <el-button :style="editStatus ? 'display:none;' : 'margin: 3px 5px;'" size="mini" type="info" @click="submitUpload" :disabled="onlySeeState" :loading="loading">开始上传</el-button>
              <el-button v-if="uploadType !== 'batch' && updateType !== 'waybill_fy' && updateType !== 'shortbill_fy' && updateType !== 'transfer_fy' && updateType !== 'delivery_fy' && updateType !== 'transaction_fy' && !onlySeeState" :style="!editStatus ? 'display:none;' : 'margin: 3px 5px;'" size="mini" type="info" @click="BeatMeterUpload" :loading="loading">拍照上传</el-button>
              <el-button v-if="uploadType !== 'batch' && updateType !== 'waybill_fy' && updateType !== 'shortbill_fy' && updateType !== 'transfer_fy' && updateType !== 'delivery_fy' && updateType !== 'transaction_fy' && !onlySeeState" style="margin: 3px 5px;" :type="editStatus ? 'danger' : 'success'" :loading="openLoading" size="mini" @click="openBeatMeter" icon="el-icon-camera">{{editStatus ? '关闭' : '拍照'}}</el-button>
              <!--              <el-button slot="trigger" size="mini" type="primary" icon="el-icon-upload2">点击上传</el-button>-->
            </el-upload>
          </el-form-item>
        </el-form>
        <template v-if="editStatus">
          <video id="videoMark" width="400px" height="250px" autoplay="autoplay"></video>
          <canvas id="canvasMark" style="display:none" width="3742" height="2806"></canvas>
        </template>
      </el-card>
    </el-col>
    <el-col :span="uploadType === 'single' ? 14 : 0">
      <el-card shadow="hover" style="height: 600px;overflow-y: auto;" class="uploadali-el-card-style">
        <div slot="header" class="clearfix">
          <el-tabs v-model="tabActiveName" type="card" @tab-click="handleClick">
            <el-tab-pane label="上传资料" name="first"></el-tab-pane>
            <el-tab-pane label="历史上传资料" name="second"></el-tab-pane>
          </el-tabs>
          <el-button v-if="tabActiveName === 'first'" style="float: right;padding: 3px 0;font-size: 13px;" type="text" @click="batch_download">批量下载</el-button>
        </div>
        <el-collapse v-model="activeName" accordion>
          <el-collapse-item name="picture">
            <template slot="title">
              图片 Picture<i class="header-icon el-icon-info"></i>
            </template>
            <div class="uploadImage" v-for="(item, index) in srcList" :key="item.url">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="item.url"
                  :preview-src-list="listString(srcList)">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <div>
                <span>{{item.sgFileType}}</span>
                <el-tooltip effect="dark" :content="item.fileName" placement="bottom-start">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </div>
              <!-- 遮罩层 -->
              <div class="optionMark" v-if="!onlySeeState && tabActiveName === 'first'">
                <div class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview">
                    <i class="el-icon-delete" @click="val => handlePictureCardRemove(item, index, val)"></i>
                  </span>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="file">
            <template slot="title">
              文件 File<i class="header-icon el-icon-info"></i>
            </template>
            <div v-for="(item, index) in fileSrcList" :key="item.url" class="file_download">
              <el-col :span="updateType === 'cusAberrant' ? 12 : 20">
                <span class="font-bold">{{item.sgFileType}}：</span>
                <span>{{item.fileName}}</span>
              </el-col>
              <el-col v-if="updateType === 'cusAberrant'" :span="8" style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;">
                <span style="font-size: 12px;color: #909399;">上传时间:{{item.createTime}}</span>
                <span style="font-size: 12px;color: #909399;">上传人:{{item.createUserName}}</span>
              </el-col>
              <el-col :span="4">
                <div class="file_download_delete">
                  <!--                <i style="margin-right: 20px; font-size: 14px;" class="el-icon-download" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                  <!--                <i style="font-size: 14px;" class="el-icon-delete" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                  <el-button style="margin-right: 10px;" type="primary" circle size="mini" icon="el-icon-download" title="下载" @click="val => handleFileDownload(item, index, val)"></el-button>
                  <el-button v-if="tabActiveName === 'first'" type="danger" circle size="mini" icon="el-icon-delete" title="删除" :disabled="onlySeeState" @click="val => handleFileDelete(item, index, val)"></el-button>
                </div>
              </el-col>
            </div>
          </el-collapse-item>
          <el-collapse-item name="video">
            <template slot="title">
              音频 Music/视频 Video<i class="header-icon el-icon-info"></i>
            </template>
            <!--            <img src="./music.png" alt="" style="width: 50px;">-->
            <!--            <div>音频 audio</div>-->
            <!--            <img src="./video.png" alt="" style="width: 50px;">-->
            <!--            <div>视频 video</div>-->
            <div v-for="(item, index) in videoSrcList" :key="item.url" class="file_download">
              <div v-if="item.fileType === 'video'">
                <el-col :span="20">
                  <span class="font-bold">{{item.sgFileType}}：</span>
                  <span>{{item.fileName}}</span>
                </el-col>
                <el-col :span="4">
                  <div class="file_download_delete">
                    <!--                <i style="margin-right: 20px; font-size: 14px;" class="el-icon-download" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                    <!--                <i style="font-size: 14px;" class="el-icon-delete" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                    <el-button style="margin-right: 10px;" type="primary" circle size="mini" icon="el-icon-download" title="下载" @click="val => handleVideoDownload(item, index, val)"></el-button>
                    <el-button type="danger" circle size="mini" icon="el-icon-delete" title="删除" @click="val => handleVideoDelete(item, index, val)"></el-button>
                  </div>
                </el-col>
              </div>
              <div v-if="item.fileType === 'music'">
                <el-col :span="20">
                  <span class="font-bold">{{item.sgFileType}}：</span>
                  <span>{{item.fileName}}</span>
                </el-col>
                <el-col :span="4">
                  <div class="file_download_delete">
                    <!--                <i style="margin-right: 20px; font-size: 14px;" class="el-icon-download" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                    <!--                <i style="font-size: 14px;" class="el-icon-delete" @click="val => handlePictureCardRemove(item, index, val)"></i>-->
                    <el-button style="margin-right: 10px;" type="primary" circle size="mini" icon="el-icon-download" title="下载" @click="val => handleVideoDownload(item, index, val)"></el-button>
                    <el-button v-if="tabActiveName === 'first'" type="danger" circle size="mini" icon="el-icon-delete" title="删除" :disabled="onlySeeState" @click="val => handleVideoDelete(item, index, val)"></el-button>
                  </div>
                </el-col>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>

import store from '@/store/index'
import {
  uploadAli, delOssData, getOssObjectList, getOssDeleteList
} from '@/api/basic/customer'
import { addUploadAliAccident, getSgOssType } from '@/api/tms/tmssg'
import { aliBatchSalesDownload } from '@/api/tms/accfp'
import axios from 'axios'
import dayjs from 'dayjs'
import { validatenull } from '@/tdcommon/validate'
import { takePicture, dtaURItoBlob } from '@/tdcommon/beeutil'
import {getLogisticOssType, uploadAliLogistic, uploadAliLogisticBatch} from '@/api/basic/logistic'

export default {
  name: 'd2-container-uploadAli-insurance-track',
  data () {
    return {
      loading: false,
      fileList: [],
      fileListMsg: [],
      formData: [],
      resultData: [],
      totalNumbers: 0,
      importNumbers: 0,
      filelistdata: {},
      uploadData: { module: this.customerType },
      headers: {
        'Authorization': 'Bearer ' + store.getters.access_token,
        'TENANT-ID': 1
      },
      uploadForm: [],
      tabActiveName: 'first',
      activeName: 'picture',
      // srcList: [
      //   'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
      //   'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg'
      // ],
      srcList: [],
      fileSrcList: [],
      videoSrcList: [],
      updateNo: '',
      updateType: '',
      uploadStatus: false,
      editStatus: false, // 当前状态
      openLoading: false,
      auditStatus: '', // 上传审核状态
      auditText: '', // 已审核的文字提示
      auditType: '', // 回单管理（电子/纸质）
      updateId: '', // 回单ID
      uploadClassify: '', // 上传分类
      onlySeeState: false,
      // 选择图片同步运单
      syncPictureVisible: false,
      checkedPictures: [],
      syncCheckNum: 0,
      syncCheckSelect: [],
      syncLoading: false,
      syncTableData: [],
      activeTrack: '0',
      radio4: '',
      radio3: '',
      radio2: '',
      radio1: '',
      radio0: '',
      trackForm: {
        fileList: [],
        certificate: [],
        videoPhoto: [],
        information: [],
        all: []
      }
    }
  },
  props: {
    // percentage: {
    //   type: Number,
    //   default: () => 0
    // },
    importVisible: {
      type: Boolean,
      default: () => false
    },
    uploadVisible: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    multiple: {
      type: Boolean,
      default: () => false
    },
    // url: {
    //   type: String,
    //   default: () => '/basic/dtcustomer/import/yyd'
    // },
    // customerNo: {
    //   type: String,
    //   default: () => ''
    // },
    customerType: {
      type: String,
      default: () => ''
    },
    docId: {
      type: Number,
      default: () => null
    },
    docType: {
      type: String,
      default: () => ''
    },
    // 上传类型：单个 single、批量 batch
    uploadType: {
      type: String,
      default: () => 'single'
    }
  },
  watch: {
    customerType: function (val, oldVal) {
      this.$set(this.uploadData, 'module', val)
    }
  },
  mounted () {
    // this.init()
  },
  methods: {
    validateNull (val) {
      return validatenull(val)
    },
    init (updateType) {
      // 获取上传分类
      if (updateType === 'accident') {
        getSgOssType().then(res => {
          if (res.code === 0) {
            this.trackForm.all = res.data['0']
            this.trackForm.fileList = res.data['1']
            this.trackForm.certificate = res.data['2']
            this.trackForm.videoPhoto = res.data['3']
            this.trackForm.information = res.data['4']
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (updateType === 'carrier') {
        getLogisticOssType().then(res => {
          if (res.code === 0) {
            this.trackForm.all = res.data['0']
            this.trackForm.fileList = res.data['1']
            this.trackForm.certificate = res.data['2']
            this.trackForm.videoPhoto = res.data['3']
            this.trackForm.information = []
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    radioInput (val, type) {
      this.uploadData.sgFileType = val
      // 定义一个所有类型的数组
      const allTypes = ['0', '1', '2', '3', '4'];
      // 过滤出其他类型
      const otherTypes = allTypes.filter(t => t !== type)
      // 清空其他类型的radio值
      otherTypes.forEach(t => {
        this[`radio${t}`] = ''
      })
    },
    getActiveFirst (type) {
      this.activeName = type
    },
    handleClick () {
      if (this.tabActiveName === 'first') {
        this.getOssReturnData() // 调用返回数据接口
      } else if (this.tabActiveName === 'second') {
        this.getOssDeleteData() // 调用历史资料返回数据接口
      }
    },
    // 上传
    async submitUpload (importType) {
      this.loading = true
      if (!validatenull(this.fileListMsg)) { // 判断文件是否为空
        if (validatenull(this.uploadData.sgFileType)) {
          this.$message.error('请先选择上传分类！')
          this.loading = false
          return
        }
        if (this.auditStatus === '1') { // 判断上传是否已审核
          this.$message.error(this.auditText + '，不能更改！上传文件请先反审核！')
          this.loading = false
        } else {
          try {
            // 创建所有保存请求的Promise数组
            const promiseArr = this.fileListMsg.map(async (file) => {
              try {
                // 第一步：获取阿里云上传Sign
                const uploadSign = await this.getUploadAliSign()

                // 第二步：使用获取到的Sign上传文件
                var data = uploadSign.data
                var ossData = new FormData()
                let fileNamePoint = file.raw.name.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
                let fileNameLength = file.raw.name.length // 取到文件名长度
                let imgType = file.raw.name.substring(fileNamePoint + 1, fileNameLength).toLocaleLowerCase() // 截  所有后缀格式转小写
                var fileName = ''
                if (this.uploadType === 'batch') {
                  fileName = dayjs(new Date()).format('YYYYMMDDHHmmss') + Math.random().toString().substr(2, 3) + file.raw.name // 上传阿里保存 文件名=日期+3位随机码+原有文件名
                } else {
                  fileName = this.updateNo + Math.random().toString().substr(2, 3) + file.raw.name // 上传阿里保存 文件名=单位编码+3位随机码+原有文件名
                }
                let keyValue = data.dir + fileName
                ossData.append('name', fileName)
                ossData.append('key', keyValue)
                ossData.append('policy', data.policy)
                ossData.append('OSSAccessKeyId', data.accessid)
                ossData.append('success_action_status', 200)
                ossData.append('signature', data.signature)
                ossData.append('callback', data.callback)
                ossData.append('file', file.raw, file.raw.name)
                const uploadResult = await this.uploadAliMsg(data, ossData)

                if (uploadResult.status === 200) {
                  let fileType = ''
                  if (imgType === 'jpg' || imgType === 'jpeg' || imgType === 'png' || imgType === 'gif') { // .jpg,.jpeg,.png,.gif
                    fileType = 'picture'
                  } else if (imgType === 'xls' || imgType === 'xlsx' || imgType === 'doc' || imgType === 'docx' || imgType === 'pdf') { // xls,.xlsx,.doc,.docx,.pdf
                    fileType = 'file'
                  } else if (imgType === 'avi' || imgType === 'wmv' || imgType === 'mpeg' || imgType === 'mov' || imgType === 'rm' || imgType === 'rmvb' || imgType === 'flv' || imgType === 'mkv' || imgType === 'mp4') { // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
                    fileType = 'video'
                  } else if (imgType === 'mp3' || imgType === 'wma' || imgType === 'flac' || imgType === 'ape' || imgType === 'wav' || imgType === 'aac' || imgType === 'm4a') { // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
                    fileType = 'music'
                  }
                  // 第三步：使用获取到的URL保存到后台
                  const saveResult = await this.saveUploadAli(keyValue, fileName, fileType)
                  return saveResult
                }
              } catch (error) {
                // 如果单个文件失败，抛出错误，让 Promise.all 能够捕获
                // throw new Error(`上传保存文件 ${file.raw.name} 失败: ${error.message}`)
                this.$notify.error({
                  title: '错误',
                  message: `上传保存文件 ${file.raw.name} 失败: ${error.message}`
                })
                // this.$message.error(`上传保存文件 ${file.raw.name} 失败: ${error.message}`)
              }
            })
            console.log('promiseArr', promiseArr)
            // 等待所有保存请求完成
            await Promise.all(promiseArr)
            this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
            this.fileListMsg = [] // 清空handlechange的文件缓存
            if (this.updateType === 'accident') {
              this.$emit('refreshClick') // 调父组件刷新表格时间
            }
            if (this.uploadType !== 'batch') {
              // 所有保存完成后，调用查询接口
              await this.getOssReturnData()
            }
            this.$message.success('上传成功！')
          } catch (error) {
            console.error('上传失败:', error)
            // this.$message.error('上传失败' + error)
            this.$notify.error({
              title: '错误',
              message: '上传失败' + error
            })
          } finally {
            console.error('上传finally')
            this.loading = false
          }
        }
      } else {
        this.$message.error('请选择上传文件！')
        this.loading = false
      }
    },
    // 获取上传Sign
    getUploadAliSign () {
      console.log('获取上传Sign')
      return uploadAli()
    },
    // 上传文件
    uploadAliMsg (data, ossData) {
      console.log('上传文件')
      return axios.post(data.host, ossData, { headers: { 'Content-Type': 'multipart/form-data' } })
    },
    // 保存到后台
    saveUploadAli (keyValue, fileName, fileType) {
      if (this.updateType === 'accident') { // 事故保险材料上传
        return addUploadAliAccident(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          sgFileType: this.uploadData.sgFileType, // 文件分类
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'carrier' && this.uploadType === 'single') { // 承运单位 资质上传
        return uploadAliLogistic(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          sgFileType: this.uploadData.sgFileType, // 文件分类
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      } else if (this.updateType === 'carrier' && this.uploadType === 'batch') { // 批量上传 承运单位的资质
        return uploadAliLogisticBatch(Object.assign({
          url: 'https://file.56tms.com/' + keyValue,
          fileName: fileName,
          objectNo: this.updateNo, // 单位编号
          source: 'tms', // 来源
          module: this.customerType, // 模块设置为单据类型
          itemType: this.uploadClassify, // 类型
          fileType: fileType, // 文件类型
          sgFileType: this.uploadData.sgFileType, // 文件分类
          fileDesc: this.uploadData.fileDesc // 文件说明
        }))
      }
    },
    async picUpload (file) {
      uploadAli().then(response => {
        // console.log('uploadAli', response)
        var data = response.data
        var ossData = new FormData()
        // var imgType = file.raw.name.split('.')[1]
        let fileNamePoint = file.raw.name.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
        let fileNameLength = file.raw.name.length // 取到文件名长度
        let imgType = file.raw.name.substring(fileNamePoint + 1, fileNameLength).toLocaleLowerCase() // 截  所有后缀格式转小写
        // console.log('fileName', fileNamePoint + 1)
        // console.log('fileNameLength', fileNameLength)
        // console.log('imgType', imgType)
        // var fileName = this.updateNo + '_' + dayjs(new Date()).format('YYYYMMDDHHmmssSSS') + Math.random().toString().substr(2, 4) + '.' + imgType // 上传阿里保存 文件名=单位编码+日期（年月日时分秒+毫秒3位数）+4位随机码+文件类型
        var fileName = this.updateNo + Math.random().toString().substr(2, 3) + file.raw.name // 上传阿里保存 文件名=单位编码+3位随机码+原有文件名
        ossData.append('name', fileName)
        // key就代表文件层级和阿里云上的文件名
        // let filename = file.file.name + file.file.size
        // let keyValue = data.dir + '/' + filename + '.' + imgType
        let keyValue = data.dir + fileName
        ossData.append('key', keyValue)
        ossData.append('policy', data.policy)
        ossData.append('OSSAccessKeyId', data.accessid)
        ossData.append('success_action_status', 200)
        ossData.append('signature', data.signature)
        ossData.append('callback', data.callback)
        ossData.append('file', file.raw, file.raw.name)
        axios.post(data.host, ossData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          let fileType = ''
          if (imgType === 'jpg' || imgType === 'jpeg' || imgType === 'png' || imgType === 'gif') { // .jpg,.jpeg,.png,.gif
            fileType = 'picture'
          } else if (imgType === 'xls' || imgType === 'xlsx' || imgType === 'doc' || imgType === 'docx' || imgType === 'pdf') { // xls,.xlsx,.doc,.docx,.pdf
            fileType = 'file'
          } else if (imgType === 'avi' || imgType === 'wmv' || imgType === 'mpeg' || imgType === 'mov' || imgType === 'rm' || imgType === 'rmvb' || imgType === 'flv' || imgType === 'mkv' || imgType === 'mp4') { // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
            fileType = 'video'
          } else if (imgType === 'mp3' || imgType === 'wma' || imgType === 'flac' || imgType === 'ape' || imgType === 'wav' || imgType === 'aac' || imgType === 'm4a') { // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
            fileType = 'music'
          }
          if (res.status === 200) {
            // let url = data.host // 上传阿里保存 传值URL
            if (this.updateType === 'accident') { // 事故保险材料上传
              addUploadAliAccident(Object.assign({
                url: 'https://file.56tms.com/' + keyValue,
                fileName: fileName,
                objectNo: this.updateNo, // 单位编号
                source: 'tms', // 来源
                module: this.customerType, // 模块设置为单据类型
                itemType: this.uploadClassify, // 类型
                fileType: fileType, // 文件类型
                sgFileType: this.uploadData.sgFileType, // 文件分类
                fileDesc: this.uploadData.fileDesc // 文件说明
              })).then(items => {
                if (items) {
                  this.srcList = []
                  this.fileSrcList = []
                  this.videoSrcList = []
                  this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
                  this.fileListMsg = [] // 清空handlechange的文件缓存
                  this.loading = false
                  this.uploadStatus = true
                  this.$emit('refreshClick') // 调父组件刷新表格时间
                }
              })
            }
          }
        }).catch(() => {
        })
      })
    },
    handleChange (file, fileList) {
      this.fileListMsg = fileList
    },
    handleRemove (file, fileList) {
    },
    handlePreview (file, fileList) {
    },
    handleExceed (files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    // 高拍仪拍照上传
    BeatMeterUpload () {
      if (validatenull(this.uploadData.sgFileType)) {
        this.$message.error('请先选择上传分类！')
        return
      }
      if (takePicture('videoMark', 'canvasMark', 'take', this)) {
        this.loading = true
        const tempSrc = document.getElementById('canvasMark')
        const base64Data = tempSrc.toDataURL('image/jpeg', 1.0)
        let blob = dtaURItoBlob(base64Data)
        blob.lastModifiedDate = new Date()
        blob.name = this.updateNo + '_' + dayjs(new Date()).format('YYYYMMDDHHmmssSSS') + Math.random().toString().substr(2, 4) + '.jpeg'
        var fd = { name: blob.name, percentage: 0, raw: blob, size: blob.size, status: 'ready' }
        // this.picUpload(fd)
        this.fileListMsg = []
        this.fileListMsg.push(fd)
        setTimeout(() => {
          this.submitUpload()
        }, 0)
      }
    },
    // 高拍仪设备操作
    openBeatMeter () {
      this.openLoading = true
      if (!validatenull(this.fileListMsg)) {
        this.$message.warning('请先将选择文件进行上传或删除后，再进行开启拍摄功能')
        this.openLoading = false
        return
      }
      if (!this.editStatus) {
        this.editStatus = true
        setTimeout(() => {
          takePicture('videoMark', 'canvasMark', 'open', this)
          setTimeout(() => {
            this.openLoading = false
          }, 1500)
        }, 500)
      } else {
        takePicture('videoMark', 'canvasMark', 'close', this)
        setTimeout(() => {
          this.editStatus = false
          this.openLoading = false
        }, 500)
      }
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    },
    // 判断导入的格式是不是xls、xlsx、...，如果不是则提示
    beforeAvatarUpload (file, fileList) {
      const isIMAGE = file.type === '.jpg' || '.jpeg' || '.png' || '.gif' // .jpg,.jpeg,.png,.gif
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const isFile = testmsg === '.xls' || '.xlsx' || '.doc' || '.docx' || '.pdf'
      const isVideo = testmsg === '.avi' || '.wmv' || '.mpeg' || '.mov' || '.rm' || '.rmvb' || '.flv' || '.mkv' || '.mp4' // .avi,.wmv,.mpeg,.mov,.rm,.rmvb,.flv,.mkv,.mp4
      const isMusic = testmsg === '.mp3' || '.wma' || '.flac' || '.ape' || '.wav' || '.aac' || '.m4a' // .mp3,.wma,.flac,.ape,.wav,.aac,.m4a
      const isLt2M = file.size / 1024 / 1024 < 50

      if (!isFile || !isVideo || !isMusic || !isIMAGE) {
        this.$message.error('上传文件格式不支持！')
        return false
      }
      // if (!isIMAGE) {
      //   this.$message.error('上传文件只能是图片格式!')
      // }
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 50MB!')
      }
      return (isIMAGE || isFile || isVideo || isMusic) && isLt2M
      // return isIMAGE
    },
    // 上传成功
    onSuccess (res, file, fileList) {
      // let val = ''
      // fileList.forEach(item => {
      //   if (val !== '') {
      //     val += ','
      //   }
      //   if (item.response) {
      //     val += item.response.data.downloadPath
      //   } else {
      //     val += item.url
      //   }
      // })
      // this.$emit('input', val)
      // this.uploadAliyun(res, file)
    },
    // 上传失败
    onError () {
    },
    // 获取客户编号
    getupdateNo (cusNo, type, auditStatus, classify, auditText, auditType, updateId) {
      this.tabActiveName = 'first'
      this.updateNo = cusNo
      this.updateType = type
      this.auditStatus = auditStatus // 上传审核状态（'1'为已审核，'0'为未审核，'2'为不通过）
      this.uploadClassify = classify // 上传分类
      this.auditText = auditText // 已审核的文字提示
      this.auditType = auditType // 回单管理（电子/纸质）
      this.updateId = updateId // 回单ID
      this.$set(this.uploadData, 'objectNo', cusNo)
    },
    // 只查看附件 调取事件
    getOssOnlySee (status) {
      this.onlySeeState = status
    },
    // 关闭时清空srclist
    clearSrcList () {
      this.srcList = []
      this.fileSrcList = []
      this.videoSrcList = []
      if (this.editStatus) {
        takePicture('videoMark', 'canvasMark', 'close', this)
        this.editStatus = false
        this.openLoading = false
      }
      this.$set(this.uploadData, 'objectNo', '') // 清空编号
      this.$set(this.uploadData, 'fileDesc', '') // 清空文件说明
      this.$refs.refUploadAli.clearFiles() // 清空上传文件列表
    },
    listString (imageList) {
      var imageArray = []
      imageList.forEach(item => {
        imageArray.push(item.url)
      })
      return imageArray
    },
    // 获取上传返回的数据
    getOssReturnData () {
      const loading = this.$loading({
        lock: true,
        text: '正在加载中，请稍等。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.loading = true
      this.tabActiveName = 'first' // 上传后 切换
      getOssObjectList(Object.assign({
        objectNo: this.updateNo,
        itemType: this.uploadClassify
      })).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.srcList = []
          this.fileSrcList = []
          this.videoSrcList = []
          if (validatenull(res.data)) {
            loading.close()
            this.setDefaultActive()
            return
          }
          res.data.forEach(urls => {
            // let option = {}
            // option.id = urls.id
            // option.url = urls.url
            // option.fileName = urls.fileName
            // option.itemType = urls.itemType
            // option.fileType = urls.fileType
            // option.createUserName = urls.createUserName
            // option.createTime = urls.createTime
            if (urls.fileType === 'picture') {
              this.srcList.push(urls)
            } else if (urls.fileType === 'file') {
              this.fileSrcList.push(urls)
            } else if (urls.fileType === 'video' || urls.fileType === 'music') {
              this.videoSrcList.push(urls)
            }
          })
          setTimeout(() => {
            loading.close()
            this.setDefaultActive()
          }, 500)
        } else {
          this.srcList = []
          this.fileSrcList = []
          this.videoSrcList = []
          loading.close()
          this.setDefaultActive()
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.srcList = []
        this.fileSrcList = []
        this.videoSrcList = []
        loading.close()
        this.setDefaultActive()
        this.loading = false
      })
    },
    // 获取上传删除后的历史资料返回的数据
    getOssDeleteData () {
      const loading = this.$loading({
        lock: true,
        text: '正在加载中，请稍等。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.loading = true
      getOssDeleteList(Object.assign({
        objectNo: this.updateNo,
        itemType: this.uploadClassify
      })).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.srcList = []
          this.fileSrcList = []
          this.videoSrcList = []
          if (validatenull(res.data)) {
            loading.close()
            this.setDefaultActive()
            return
          }
          res.data.forEach(urls => {
            // let option = {}
            // option.id = urls.id
            // option.url = urls.url
            // option.fileName = urls.fileName
            // option.itemType = urls.itemType
            // option.fileType = urls.fileType
            if (urls.fileType === 'picture') {
              this.srcList.push(urls)
            } else if (urls.fileType === 'file') {
              this.fileSrcList.push(urls)
            } else if (urls.fileType === 'video' || urls.fileType === 'music') {
              this.videoSrcList.push(urls)
            }
          })
          setTimeout(() => {
            loading.close()
            this.setDefaultActive()
          }, 500)
        } else {
          this.srcList = []
          this.fileSrcList = []
          this.videoSrcList = []
          loading.close()
          this.setDefaultActive()
          this.$message.error(res.msg)
        }
      }).catch(() => {
        this.srcList = []
        this.fileSrcList = []
        this.videoSrcList = []
        loading.close()
        this.setDefaultActive()
        this.loading = false
      })
    },
    setDefaultActive () {
      if (!validatenull(this.srcList)) {
        this.activeName = 'picture'
      } else if (!validatenull(this.fileSrcList)) {
        this.activeName = 'file'
      } else if (!validatenull(this.videoSrcList)) {
        this.activeName = 'video'
      } else {
        this.activeName = 'picture'
      }
    },
    // 预览返回图片
    handlePictureCardPreview (file) {
      // this.$refs.image_refs.clickHandler()
    },
    // 删除返回图片
    handlePictureCardRemove (option, index, val) {
      if (this.auditStatus === '1') {
        this.$message.error(this.auditText + '，不能更改！删除图片请先反审核！')
      } else {
        delOssData(option.id).then(item => {
          if (item.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.srcList.splice(index, 1) // 前端页面移除
          } else {
            this.$message.error(item.msg)
          }
        })
      }
    },
    batch_download () {
      const loading = this.$loading({
        lock: true,
        text: '正在下载中，请稍等。。。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      aliBatchSalesDownload(Object.assign({
        objectNo: this.uploadData.objectNo,
        itemType: this.uploadClassify
      })).then(response => {
        let blob = new Blob([response], { type: 'application/zip' })
        let url = window.URL.createObjectURL(blob)
        const link = document.createElement('a') // 创建a标签
        link.href = url
        link.download = this.customerType + this.updateNo // 重命名文件
        link.click()
        URL.revokeObjectURL(url) // 释放内存
        setTimeout(() => {
          loading.close()
        }, 2000)
      })
    },
    // 下载返回文件
    handleFileDownload (option, index, val) {
      let fileNamePoint = option.fileName.lastIndexOf('.') // 取到文件名开始到最后一个点的长度
      let fileNameLength = option.fileName.length // 取到文件名长度
      let imgType = option.fileName.substring(fileNamePoint + 1, fileNameLength) // 截

      if (imgType === 'pdf') { // 如果文件类型是pdf
        window.open(option.url)
      } else { // 如果是其他文件类型
        const ele = document.createElement('a')
        ele.setAttribute('href', option.url) // 设置下载文件的url地址
        ele.setAttribute('download', option.fileName) // 用于设置下载文件的文件名
        ele.click()
      }
    },
    // 下载返回音频、视频
    handleVideoDownload (option, index, val) {
      // const ele = document.createElement('a')
      // ele.setAttribute('href', option.url) // 设置下载文件的url地址
      // ele.setAttribute('download', option.fileName) // 用于设置下载文件的文件名
      // ele.click()
      // 将lob对象转换为域名结合式的url
      // const link = document.createElement('a')
      // link.style.display = 'none'
      // // 设置a标签的下载属性，设置文件名及格式，后缀名最好让后端在数据格式中返回
      // link.download = option.fileName
      // var blob = new Blob(option.url)
      // link.href = URL.createObjectURL(blob)
      // // 自触发click事件
      // document.body.appendChild(link)
      // link.click()
      // document.body.removeChild(link)
      window.open(option.url)
    },
    // 删除返回文件
    handleFileDelete (option, index, val) {
      if (this.auditStatus === '1') {
        this.$message.error(this.auditText + '，不能更改！删除文件请先反审核！')
      } else {
        delOssData(option.id).then(item => {
          if (item.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.fileSrcList.splice(index, 1) // 前端页面移除
          } else {
            this.$message.error(item.msg)
          }
        })
      }
    },
    // 删除返回音频、视频
    handleVideoDelete (option, index, val) {
      if (this.auditStatus === '1') {
        this.$message.error(this.auditText + '，不能更改！删除音频、视频请先反审核！')
      } else {
        delOssData(option.id).then(item => {
          if (item.code === 0) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.videoSrcList.splice(index, 1) // 前端页面移除
          } else {
            this.$message.error(item.msg)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.uploadali-el-card-style {
    .el-card__header {
        padding: 14px 20px !important;
        border-bottom: 0 !important;
    }
    .el-upload-list {
      max-height: 233px;
      overflow-y: auto;
    }
}
.uploadImage {
    position: relative;
    display: inline-block;
    margin-left: 17px;
    .optionMark {
        display: none;
        position: absolute;
        width: 50px;
        height: 50px;
        left: 50px;
        top: 50px;
        background:linear-gradient(to top left,rgba(0,0,0,.5) 40%,transparent 40%);

        .el-upload-list__item-actions {
            position: absolute;
            font-size: 15px;
            left: 6px;
            top: 26px;
            width: 100%;
            height: 100%;
            text-align: right;
            color: #fff;
            transition: opacity .3s;
        }
    }
}
.uploadImage:hover {
    .optionMark {
        display: block;
        z-index: 999;
        .el-upload-list__item-preview {
            cursor: pointer;
        }
    }
}
.file_download {
  display: flex;
  justify-content: center;
  align-items: center;
  //border-bottom: 1px solid #EBEEF5;
}
/*文件下载删除 鼠标移入样式改变*/
.file_download:hover{
    cursor: pointer;
    .file_download_delete{display: block};
}
/*文件下载删除按钮*/
.file_download_delete{
  display: none;
}
.syncPicture_dialog {
  border-radius: 12px;
  .el-dialog__body {
    padding: 20px 40px 20px 0;
    .el-table-column--selection .cell {
      padding-right: 10px;
    }
  }
}
</style>
<style lang="scss" scoped>
.trackTab::v-deep {
  margin-bottom: 10px;
  .el-tabs__item {
    padding: 0 0 !important;
    height: 40px;
    line-height: 100%;
  }
  .el-radio {
    border-radius: 8px;
    text-align: center;
    margin-right: 10px;
    margin-bottom: 5px;
  }
  .el-radio.is-bordered+.el-radio.is-bordered {
    margin-left: 0;
  }
  .el-radio__input {
    display: none;
  }
  .el-radio__label {
    padding-left: 0;
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-uploadAli-insurance-track/index.vue"
}
</vue-filename-injector>
